import { exitViewAs, viewAsInfo } from './viewAs'

// Everything a login leaves behind (the sidebars' and agent portal's Log out).
const SESSION_KEYS = ['user-enatega', 'vendorId', 'restaurant_id', 'restaurantId', 'restaurantName', 'restaurantImage']

function storedToken(key) {
  try {
    return (JSON.parse(localStorage.getItem(key)) || {}).token || null
  } catch (e) {
    return null
  }
}

// The signed-in admin/vendor/agent token lives in localStorage 'user-enatega'
// and is read on every request (src/index.js). A password change or "sign out
// of all devices" hands back a fresh token for this device (backend migration
// 137); this swaps it in so this device stays signed in.
export function replaceSessionToken(token) {
  if (!token) return
  try {
    const data = JSON.parse(localStorage.getItem('user-enatega') || '{}')
    localStorage.setItem('user-enatega', JSON.stringify({ ...data, token }))
  } catch (e) {
    // Nothing stored to update.
  }
}

/**
 * The server refused the login a request carried: past its 30 days, signed
 * out everywhere, or signed with a retired key (backend middleware/auth.js
 * marks the response). Sign out the way Log out does and show the login page,
 * instead of every page saying "Unauthenticated". `sentToken` is the token
 * that request used; if a newer login has replaced it since, nothing happens.
 */
export function endRejectedSession(sentToken, client) {
  if (!sentToken) return
  if (storedToken('user-enatega') === sentToken) {
    // A super admin's view-as login ran out: back to their own.
    if (viewAsInfo()) {
      exitViewAs(client)
      return
    }
    SESSION_KEYS.forEach(k => localStorage.removeItem(k))
  } else if (storedToken('staff-session') === sentToken) {
    localStorage.removeItem('staff-session')
  } else {
    return
  }
  // Already on the login page (the refused request was the login itself): stay.
  if (!window.location.hash.startsWith('#/auth')) window.location.hash = '#/auth/login'
  // After the page has left, so its queries don't flash a "store reset" error.
  setTimeout(() => client.clearStore().catch(() => {}), 0)
}

/** The signed-in account's id, from the stored login. */
export function sessionUserId() {
  try {
    return JSON.parse(localStorage.getItem('user-enatega') || '{}').userId || null
  } catch (e) {
    return null
  }
}

/** "5 min ago", "3 h ago", "2 days ago", then the date. */
export function timeAgo(iso) {
  if (!iso) return null
  const t = new Date(iso).getTime()
  if (!Number.isFinite(t)) return null
  const mins = Math.round((Date.now() - t) / 60000)
  if (mins < 1) return 'Just now'
  if (mins < 60) return `${mins} min ago`
  const hours = Math.round(mins / 60)
  if (hours < 24) return `${hours} h ago`
  const days = Math.round(hours / 24)
  if (days < 14) return `${days} day${days === 1 ? '' : 's'} ago`
  return new Date(t).toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' })
}
